import { Button, ButtonProps } from '@sgme/ui';
import { useFormAnalytics } from 'components/form-analytic-provider';
import { useAppSelector } from 'hooks/useAppSelector';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { IntlKey } from 'locales';
import { MouseEventHandler, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { useQuote } from 'routes/essential-workspace/hooks/use-quote';
import {
  selectIsEssentialCrossBrowserFrozen,
  selectIsEssentialFormDirty,
} from 'routes/essential-workspace/state/form.selectors';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { selectEssentialsActions } from 'state/essential/infos/selectors';
import { essentialPriceRequestedThunk } from 'state/essential/thunks';

export function PriceQuoteAction({
  labelTranslationKey,
  icon,
  ...props
}: { icon?: ReactNode; labelTranslationKey?: IntlKey } & ButtonProps) {
  const { formId } = useQuote();
  const actions = useAppSelector(state => selectEssentialsActions(state, formId));
  const isFormDirty = useAppSelector(state => selectIsEssentialFormDirty(state, formId));
  const isCrossBrowserFrozen = useAppSelector(state => selectIsEssentialCrossBrowserFrozen(state, formId));
  const dispatch = useThunkDispatch();
  const { trackSubmitForm } = useFormAnalytics();

  const indicativeQuoteAction = actions.find(action => action.name === 'IndicativeQuote');

  const isActionDisabled = indicativeQuoteAction?.isDisabled || isFormDirty || isCrossBrowserFrozen;

  const onPrice: MouseEventHandler<HTMLButtonElement> = event => {
    event.stopPropagation();
    dispatch(essentialPriceRequestedThunk(formId, 'Indicative'));
    trackSubmitForm();
    logAnalytics.trackEvent('Primary market essential', 'Request for quote');
  };

  if (!indicativeQuoteAction) {
    return null;
  }

  return (
    <Button size="xl" purpose="flat" {...props} disabled={isActionDisabled} onClick={onPrice}>
      {!!labelTranslationKey && <FormattedMessage id={labelTranslationKey} />}
      {icon}
    </Button>
  );
}
